import { useLayoutEffect, useRef } from "react";
import type { MutableRefObject } from "react";

/**
 * Returns a ref that tracks the latest value after layout (safe for stable subscribe callbacks).
 *
 * @typeParam T Value type held in the ref.
 * @param value Latest value to mirror into the ref.
 * @returns Ref updated in `useLayoutEffect`, not during render.
 */
export const useLayoutRef = <T>( value: T ): MutableRefObject<T> => {
    const ref = useRef( value );

    useLayoutEffect( () => {
        ref.current = value;
    } );

    return ref;
};
